// import { takeLatest } from '@redux-saga/core/effects'
import { takeCustomLatest } from 'state/common/common.effects'
import { OrderSummaryActions, setLoaderAction } from './orderSummary.actions'
import {
  getOrderGroupSummaryEffect,
  getOrderSummaryEffect,
  downloadOrderSummarySagaEffect,
  getOverallOrderGroupSummaryEffect,
  downloadOverallGroupSummaryEffect
} from './orderSummary.effects'

function* getOrderSummarySaga() {
  yield takeCustomLatest(OrderSummaryActions.GET_ORDER_SUMMARY, getOrderSummaryEffect, () =>
    setLoaderAction({ id: 'listSummary', value: false })
  )
}

function* getOrderGroupSummarySaga() {
  yield takeCustomLatest(
    OrderSummaryActions.GET_ORDER_GROUP_SUMMARY,
    getOrderGroupSummaryEffect,
    () => setLoaderAction({ id: 'groupSummary', value: false })
  )
}

function* downloadOrderSummarySaga() {
  yield takeCustomLatest(OrderSummaryActions.DOWNLOAD_ORDER_SUMMARY, downloadOrderSummarySagaEffect)
}

function* getOverallOrderGroupSummarySaga() {
  yield takeCustomLatest(
    OrderSummaryActions.GET_OVERALL_ORDER_GROUP_SUMMARY,
    getOverallOrderGroupSummaryEffect,
    () => setLoaderAction({ id: 'overallGroupSummary', value: false })
  )
}

function* downloadOverallGroupSummarySaga() {
  yield takeCustomLatest(
    OrderSummaryActions.DOWNLOAD_OVERALL_ORDER_GROUP_SUMMARY,
    downloadOverallGroupSummaryEffect
  )
}

export const OrderSummaryWatcher = [
  getOrderSummarySaga(),
  getOrderGroupSummarySaga(),
  downloadOrderSummarySaga(),
  getOverallOrderGroupSummarySaga(),
  downloadOverallGroupSummarySaga()
]
